import { MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, OnInit, Inject, ViewChild, AfterViewInit } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, MatSortable } from '@angular/material/sort';
import { DateHelper } from 'src/app/core/helpers/date.helper';
import { IOpaEquipeModel } from 'src/app/models/opa-equipe.model';
import { IAuditorCoordenacaoModel } from 'src/app/models/auditor-coordenacao.model';
import { ITipoAuditoriaModel } from 'src/app/models/tipo-auditoria.model';
import { IOpaEquipeAuditorModel } from 'src/app/models/opa-equipe-auditor.model';
import Swal from 'sweetalert2';
import { IAlocarEquipeModel, IAuditorModel } from "../../../models/alocar-equipe-component";
import { CoordenacaoService } from "../../../services/coordenacao.service";

@Component({
  selector: 'app-modal-alocar-equipe-osa',
  templateUrl: './modal-alocar-equipe-osa.component.html',
  styleUrls: ['./modal-alocar-equipe-osa.component.scss'],
})
export class ModalAlocarEquipeOsaComponent implements OnInit {
  public model: IAlocarEquipeModel = {} as IAlocarEquipeModel;
  public dataObrigatoria!: any;
  public auditorDataSource =
    new MatTableDataSource<IAuditorCoordenacaoModel>();
  public auditorSemDados: boolean = true;
  public auditorOutraCoordenacaoDataSource =
    new MatTableDataSource<IAuditorCoordenacaoModel>();
  public auditorOutraCoordenacaoSemDados: boolean = true;
  // public minDate!: Date;
  // public maxDate!: Date;
  public novaListaAuditores = [] as IAuditorModel[];

  @ViewChild("TableOnePaginator", { static: true })
  tableOnePaginator: MatPaginator;
  @ViewChild("tabela1", { static: true }) tabela1: MatSort;

  @ViewChild("TableTwoPaginator", { static: true })
  tableTwoPaginator: MatPaginator;
  @ViewChild("tabela2", { static: true }) tabela2: MatSort;

  constructor(
    private dialogRef: MatDialogRef<ModalAlocarEquipeOsaComponent>,
    public coordenacaoService: CoordenacaoService,
    @Inject(MAT_DIALOG_DATA) public data: IAlocarEquipeModel
  ) {
    if (data) {
      this.model = data;
    }
  }

  public obterCoordenadoresAuditoria() {
    return new Promise((resolve) => {
      this.coordenacaoService
        .obterCoordenadoresAtivos()
        .then((res) => {
          if (res.sucesso) {
            resolve(res.dados);
          } else {
            Swal.fire({
              toast: true,
              position: "top-end",
              icon: "error",
              text: res.mensagem.descricao,
              showConfirmButton: false,
              timer: 5000,
              timerProgressBar: true,
            });
          }
        })
        .catch((err) => {
          Swal.fire({
            toast: true,
            position: "top-end",
            icon: "error",
            text: err.mensagem.descricao,
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
          });
        });
    });
  }

  ngOnInit(): void {
    this.obterCoordenadoresAuditoria().then((res) => {
      // this.minDate = new Date(this.model.minDataInicio, 1 - 1, 1);
      // this.maxDate = new Date(this.model.maxDataFim, 12 - 1, 31);

      // Auditor da própria coordenação
      this.auditorDataSource.data = ((res as IAuditorCoordenacaoModel[])
        ?.filter(a => a.coordenacao.id === this.model.tipoAuditoria?.coordenacao?.id))
        ?.map((item) => {
          const selecionarAuditor = this.model.auditoresSelecionados?.find(a => a?.auditorId === item?.auditorId);
          if(selecionarAuditor?.auditorId) item.selecionado = true;
          return item
        })
      this.auditorDataSource.paginator = this.tableOnePaginator;
      this.auditorDataSource.sort = this.tabela2;
      this.auditorSemDados = this.auditorDataSource.data.length === 0;
      // Fim auditor própria coordenacão

      // Auditor de outra coordenação
      this.auditorOutraCoordenacaoDataSource.data = (res as IAuditorCoordenacaoModel[])
        ?.filter(a => a.coordenacao.id !== this.model.tipoAuditoria?.coordenacao?.id)
        ?.map((item) => {
          const selecionarAuditor = this.model.auditoresSelecionados?.find(a => a?.auditorId === item?.auditorId);
          if(selecionarAuditor?.auditorId) item.selecionado = true;
          return item
        })
      this.auditorOutraCoordenacaoDataSource.paginator = this.tableTwoPaginator;
      this.auditorOutraCoordenacaoDataSource.sort = this.tabela1;
      this.auditorOutraCoordenacaoSemDados = this.auditorOutraCoordenacaoDataSource.data.length === 0;
      // Fim auditor outra coordenação
    });
  }

  setDataObrigatoria() {}


  concatUg(a: string, b: string) {
    if (a && b) {
      return a + " - " + b;
    }
    return "";
  }

  selecionarAuditores(a: IAuditorModel[] | IAuditorCoordenacaoModel[]) {
    a.forEach((item) => {
      if (item.selecionado === true) {
        this.novaListaAuditores.push(item);
      }
    });
  }

  concluir() {
    this.selecionarAuditores(this.auditorDataSource.data);
    this.selecionarAuditores(this.auditorOutraCoordenacaoDataSource.data);

    this.model.auditoresSelecionados = this.novaListaAuditores;
    if (this.model.auditoresSelecionados.length === 0) {
      Swal.fire({
        toast: true,
        position: 'top-end',
        icon: 'warning',
        text: 'Selecione ao menos 1 auditor',
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
      });
      return;
    } else {
      this.dialogRef.close(this.model);
      return;
    }
  }

  cancelar() {
    this.dialogRef.close(false);
  }
}
